/*
 * @Description: 路由跳转控制中心
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

import Vue from 'vue'
import Router from 'vue-router'
// add by mike ma on 2021-3-4
import hiRoutes from './hi'

import aboutRoutes from './about'
import customerRoutes from './customer'
import homeRoutes from './home'
import productRoutes from './product'
import solutionRoutes from './solution'
// add by mike ma on 2021-2-27
import sportsRoutes from './sports'
import errorRoutes from './error'

Vue.use(Router)

const children = [...hiRoutes,...aboutRoutes, ...customerRoutes, ...homeRoutes, ...productRoutes, ...solutionRoutes, ...sportsRoutes]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main'], resolve),
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
    window.scroll(0,0);
    next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js